export enum OtpEventType {
  OTP_SENT = "OTP_SENT",
  OTP_DELIVERED = "OTP_DELIVERED",
  OTP_VERIFIED = "OTP_VERIFIED",
  OTP_FAILED = "OTP_FAILED",
  OTP_EXPIRED = "OTP_EXPIRED",
}

export enum OtpStatus {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  PENDING = "PENDING",
}

export enum OtpChannel {
  SMS = "SMS",
  EMAIL = "EMAIL",
  WHATSAPP = "WHATSAPP",
}

export interface OtpLog {
  id: string;
  otpless_user_id?: string;
  otpless_identifier?: string;
  session_token?: string;
  otp_code?: string;
  event_type: OtpEventType;
  status: OtpStatus;
  channel?: OtpChannel;
  provider?: string;
  delivery_time_ms?: number;
  verification_time_ms?: number;
  ip_address?: string;
  user_agent?: string;
  error_message?: string;
  metadata?: Record<string, any>;
  created_at: string;
  updated_at: string;
  user?: {
    id: string;
    full_name: string;
    preferred_email?: string;
    preferred_phone_number?: string;
  };
}

export interface OtpLogsResponse {
  logs: OtpLog[];
  pagination: {
    currentPage: number;
    lastPage: number;
    total: number;
  };
}

export interface OtpAnalyticsOverview {
  total: number;
  sent: number;
  delivered: number;
  verified: number;
  failed: number;
  successRate: number;
  deliveryRate: number;
  avgDeliveryTimeMs: number;
  avgVerificationTimeMs: number;
}

export interface OtpTimeSeriesData {
  date: string;
  total: number;
  sent: number;
  delivered: number;
  verified: number;
  failed: number;
}

export interface OtpChannelBreakdown {
  SMS: number;
  EMAIL: number;
  WHATSAPP: number;
}

export interface OtpAnalytics {
  overview: OtpAnalyticsOverview;
  timeSeries: OtpTimeSeriesData[];
  channelBreakdown: OtpChannelBreakdown;
}

export interface OtpLogFilters {
  page?: number;
  search?: string;
  event_type?: OtpEventType | "ALL";
  status?: OtpStatus | "ALL";
  channel?: OtpChannel | "ALL";
  startDate?: string;
  endDate?: string;
  userId?: string;
}

